import classNames from 'classnames/bind';

import React, { FC, HTMLAttributes } from 'react';

import styles from './Typography.module.scss';

const cx = classNames.bind(styles);

const H4: FC<HTMLAttributes<HTMLElement>> = ({ children, className, ...props }) => {
  const classes = cx('h4', className);

  return (
    <h4 className={classes} {...props}>
      {children}
    </h4>
  );
};

export default H4;
